// extracted by mini-css-extract-plugin
export default {"art-popover-prompt__footer":"PopoverPrompt_art-popover-prompt__footer__wToJn","art-popover-prompt":"PopoverPrompt_art-popover-prompt__1Mtui"};